module.exports = __webpack_public_path__ + "img/Noise.2672526d.png";